export default __webpack_public_path__ + "static/media/n12-black.b098b0d2.svg";